module.exports = __webpack_public_path__ + "static/4-837debdf69e604cdc52c4363c7bbc8db.jpeg";